import React, { useEffect, useState } from 'react';
import { Checkbox, IconButton, TextField } from 'material-ui';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import { displayValue, getDefaultCargoRequestValue } from './common';
import helpers from 'helpers';

export default function Tank({
    category,
    cargoPacking,
    disabledAll,
    modifyFields,
    errors,
}) {
    const [_errors, set_errors] = useState(errors);

    useEffect(() => {
        set_errors(errors);
    }, [errors]);
    
    const addDensity = () => {
        cargoPacking.pack.densities.push(getDefaultCargoRequestValue('density'));

        modifyFields({
            field: 'packing.pack.densities', 
            value: cargoPacking.pack.densities,
        });
    };

    const removeDensity = (index) => {
        cargoPacking.pack.densities.splice(index, 1);

        modifyFields({
            field: 'packing.pack.densities', 
            value: cargoPacking.pack.densities,
        });
    };
    
    return (
        <React.Fragment>
            { cargoPacking.pack.densities.map((densityData, dIndex) => (
                <div 
                    className='row'
                    style={{ width: '100%' }}
                    key={`densityData__${dIndex}`}
                >
                    <div className='col-xs-3'>
                        <TextField 
                            value={densityData.density || ''}
                            hintText='Density, kg/m3'
                            floatingLabelText='Density, kg/m3'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields({
                                field: `packing.pack.densities[${dIndex}].density`, 
                                value: helpers.clearLetters(e.target.value),
                            })}
                        />
                    </div>
                    <div className='col-xs-3'>
                        <TextField 
                            value={densityData.temperature || ''}
                            hintText='Temperature, °C'
                            floatingLabelText='Temperature, °C'
                            disabled={disabledAll}
                            style={{ 
                                width: '100%',
                                fontSize: '13px',
                                marginRight: '15px',
                            }}
                            onChange={e => modifyFields({
                                field: `packing.pack.densities[${dIndex}].temperature`, 
                                value: helpers.clearLetters(e.target.value),
                            })}
                        />
                    </div>
                    <div className='col-xs-1'>
                        { !dIndex ?
                            <IconButton disabled={disabledAll} style={{ margin: '30px 0 0 0' }}>
                                <ContentAddIcon
                                    onClick={() => !disabledAll && addDensity()}
                                    color='green'
                                />
                            </IconButton>
                            :
                            <IconButton disabled={disabledAll} style={{ margin: '30px 0 0 0' }}>
                                <ContentRemoveIcon
                                    onClick={() => !disabledAll && removeDensity(dIndex)}
                                    color='red'
                                />
                            </IconButton>
                        }
                    </div>
                </div>))
            }
            <div 
                className='row'
                style={{ width: '100%' }}
            >
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.pourPointMin', disabledAll,
                            )
                        }
                        disabled={disabledAll}
                        hintText='Pour Point min, °C'
                        floatingLabelText='Pour Point min, °C'
                        required
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.pourPointMin', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.pourPointMax', disabledAll,
                            )
                        }
                        errorText={_errors.pourPointMax && _errors.pourPointMax.messages[0]}
                        disabled={disabledAll}
                        hintText='Pour Point max, °C'
                        floatingLabelText='Pour Point max, °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.pourPointMax', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.boilingPointMin', disabledAll,
                            )
                        }
                        disabled={disabledAll}
                        hintText='Boiling Point min, °C'
                        floatingLabelText='Boiling Point min, °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.boilingPointMin', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.boilingPointMax', disabledAll,
                            )
                        }
                        errorText={_errors.boilingPointMax && _errors.boilingPointMax.messages[0]}
                        disabled={disabledAll}
                        hintText='Boiling Point max, °C'
                        floatingLabelText='Boiling Point max, °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.boilingPointMax', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
            </div>    
            <div 
                className='row'
                style={{ width: '100%' }}
            >
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.meltingPointMin', disabledAll,
                            )
                        }
                        disabled={disabledAll}
                        hintText='Melting Point min, °C'
                        floatingLabelText='Melting Point min, °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.meltingPointMin', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.meltingPointMax', disabledAll,
                            )
                        }
                        errorText={_errors.meltingPointMax && _errors.meltingPointMax.messages[0]}
                        disabled={disabledAll}
                        hintText='Melting Point max, °C'
                        floatingLabelText='Melting Point max, °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.meltingPointMax', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3'>
                    <Checkbox 
                        label='Flammable'
                        checked={
                            displayValue(
                                cargoPacking,
                                'pack.flammable', disabledAll, false,
                            )
                        }
                        disabled={disabledAll}
                        onCheck={
                            () => modifyFields({
                                field: 'packing.pack.flammable', 
                                value: !cargoPacking.pack.flammable,
                            })
                        }
                        style={{
                            marginTop: '28px',
                        }}
                    />
                </div>
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.flashPointMin', disabledAll,
                            )
                        }
                        disabled={!cargoPacking.pack.flammable || disabledAll}
                        hintText='Flash Point, °C'
                        floatingLabelText='Flash Point, °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.flashPointMin', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
            </div>  
            <div 
                className='row'
                style={{ width: '100%' }}
            >
                <div 
                    className='col-xs-3'
                    style={{ height: '48px', display: 'flex', alignItems: 'center' }}
                >
                    HEATING
                </div>    
            </div>
            <div 
                className='row'
                style={{ width: '100%' }}
            >
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.voyageHeatMin', disabledAll,
                            )
                        }
                        disabled={disabledAll}
                        hintText='Voyage Heat, min °C'
                        floatingLabelText='Voyage Heat, min °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.voyageHeatMin', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.voyageHeatMax', disabledAll,
                            )
                        }
                        errorText={_errors.voyageHeatMax && _errors.voyageHeatMax.messages[0]}
                        disabled={disabledAll}
                        hintText='Voyage Heat, max °C'
                        floatingLabelText='Voyage Heat, max °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.voyageHeatMax', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.loadingHeatMin', disabledAll,
                            )
                        }
                        disabled={disabledAll}
                        hintText='Loading Heat, min °C'
                        floatingLabelText='Loading Heat, min °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.loadingHeatMin', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.loadingHeatMax', disabledAll,
                            )
                        }
                        errorText={_errors.loadingHeatMax && _errors.loadingHeatMax.messages[0]}
                        disabled={disabledAll}
                        hintText='Loading Heat, max °C'
                        floatingLabelText='Loading Heat, max °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.loadingHeatMax', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
            </div>  
            <div 
                className='row'
                style={{ width: '100%', height: '92px' }}
            >
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.dischargeHeatMin', disabledAll,
                            )
                        }
                        disabled={disabledAll}
                        hintText='Discharge Heat, min °C'
                        floatingLabelText='Discharge Heat, min °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.dischargeHeatMin', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3_flex'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.dischargeHeatMax', disabledAll,
                            )
                        }
                        errorText={_errors.dischargeHeatMax && _errors.dischargeHeatMax.messages[0]}
                        disabled={disabledAll}
                        hintText='Discharge Heat, max °C'
                        floatingLabelText='Discharge Heat, max °C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '0px 5px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.dischargeHeatMax', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
                <div className='col-xs-3'>
                    <TextField 
                        value={
                            displayValue(
                                cargoPacking,
                                'pack.maxAdjacentHeat', disabledAll,
                            )
                        }
                        disabled={disabledAll}
                        hintText='Max Adjacent Heat,°C'
                        floatingLabelText='Max Adjacent Heat,°C'
                        style={{ 
                            width: '100%',
                            fontSize: '13px',
                            marginRight: '15px',
                        }}
                        onChange={e => modifyFields({
                            field: 'packing.pack.maxAdjacentHeat', 
                            value: helpers.clearLetters(e.target.value),
                        })}
                    />
                </div>
            </div> 
        </React.Fragment>
    );    
}



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/Packing/Tank.jsx